/** if possible add image sizing parameters for imgix images */
export var imageSetSize = function (h, w, src) {
    if (src === void 0) { src = ''; }
    return src.includes('imgix.net') ? "".concat(src, "?h=").concat(h, "&w=").concat(w) : src;
};
